<template>
  <div class="box">
    <div class="content w-1400">
      <div class="logo-word">
        <!-- <img class="logo-big" src="../../static/index/hualianwang.png"/> -->
        <!--        <div class="word-big">-->
        <!--          <div class="china-word">化联网</div>-->
        <!--          <div class="english-word">Ruitian Huagong</div>-->
        <!--</div>-->
      </div>
      <div class="flex-inner-right">
        <div class="flex-inner-right-box">
          <div class="flex-inner-right-box-title">创建账号</div>
          <div class="input-box">
            <el-form :model="registerForm" :rules="registerRules" ref="registerForm" label-position="left">
              <el-form-item prop="company">
                <el-input placeholder="请准确输入公司全称" v-model="registerForm.company">
                  <i slot="prefix">
                    <img :src="require('../../static/login/company.png')" alt=""/>
                  </i>
                </el-input>
              </el-form-item>
              <el-form-item prop="mobile">
                <el-input placeholder="请输入手机号" v-model="registerForm.mobile">
                  <el-select v-model="select" slot="prepend" placeholder="请选择" style="width:100px;">
                    <el-option v-for="(item,index) in areaCodeList" :key="index" :label="'+'+ item.code "
                               :value="item.code">{{ item.country }} +{{ item.code }}
                    </el-option>
                  </el-select>

                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input placeholder="请输入6-18位密码" v-model="registerForm.password" type="password" show-password>
                  <i slot="prefix">
                    <img :src="require('../../static/login/pas.png')" alt=""/>
                  </i>
                </el-input>
              </el-form-item>
              <el-form-item prop="re_password">
                <el-input placeholder="请再次输入密码" v-model="registerForm.re_password" type="password" show-password>
                  <i slot="prefix">
                    <img :src="require('../../static/login/pas.png')" alt=""/>
                  </i>
                </el-input>
              </el-form-item>
              <el-form-item prop="code">
                <el-row>
                  <el-col :span="14">
                    <el-input placeholder="请输入验证码" v-model="registerForm.code">
                      <i slot="prefix">
                        <img class="input-icon" src="../../static/login/code.png" alt=""/></i>
                    </el-input>
                  </el-col>
                  <el-col :span="9" :offset="1">
                    <div class="btn-code" v-if="time == 0" @click="getCode">
                      获取验证码
                    </div>
                    <div class="btn-code" v-else>{{ time }}秒后获取</div>
                  </el-col>
                </el-row>
              </el-form-item>
              <!--              <el-form-item label="身份" label-width="100px" prop="role">-->
              <!--                <el-radio-group v-model="registerForm.role">-->
              <!--                  <el-radio :label="1">贸易商</el-radio>-->
              <!--                  <el-radio :label="2">工厂</el-radio>-->
              <!--                </el-radio-group>-->
              <!--              </el-form-item>-->
            </el-form>
          </div>

          <div class="login-box">
            <el-button class="btn-size" type="primary" :disabled="!disAgree" @click="goRegister">立即注册
            </el-button>
            <div class="login-box-text">
              <el-checkbox v-model="disAgree" @change="changeAgree">
                已阅读并同意
                <span class="color-blue" @click.stop="showAgreement">《化联网用户注册协议》</span>
              </el-checkbox>
              <div class="top-inner">
                已有账号？
                <span class="color-blue" @click="goLogin">立即登录</span>
                |
                <span class="color-blue" @click="goHome">返回首页</span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {register, checkPhone, sendSmsCode} from "@/api/modules/user";
import {getAreaCode} from "@/api/modules/common";

export default {
  data() {
    return {
      areaCodeList: [],
      activeIndex: 1,
      registerForm: {
        company: "",
        mobile: "",
        password: "",
        re_password: "",
        code: "",
        // role: "",
      },
      disAgree: 0,
      time: "", //倒计时
      select: "86",
      registerRules: {
        mobile: [
          {required: true, message: "请输入手机号码", trigger: "blur"},
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        password: [{required: true, message: "请输入密码", trigger: "blur"},
          {
            pattern: /^.{6,18}$/,
            message: "密码长度应为6-18位",
            trigger: "blur",
          },
        ],
        re_password: [
          {required: true, message: "请输入密码", trigger: "blur"},
          {
            pattern: /^.{6,18}$/,
            message: "密码长度应为6-18位",
            trigger: "blur",
          },
          {validator: this.validatePass, trigger: "blur"},
        ],
        code: [
          {required: true, message: "请输入验证码", trigger: "blur"},
          {min: 4, max: 6, message: "验证码长度应为4-6位", trigger: "blur"},
        ],
        // role: [{ validator: this.validateRole, trigger: "blur" }],
      },
    };
  },

  computed: {},
  mounted() {
    this.init()
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    init() {
      getAreaCode().then(res => {
        if (res.data.code == 10000) {
          this.areaCodeList = res.data.data
        }
      })
    },
    // 校验手机号码格式的方法
    validateMobile(mobile) {
      const mobilePattern = /^1[3-9]\d{9}$/;
      return mobilePattern.test(mobile);
    },
    // 点击是否同意协议
    changeAgree(val) {
      this.disAgree = val;
    },
    showAgreement() {
      window.open('/#/agreement/agreement?id=1', '_blank');
    },
    // 验证密码
    validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.registerForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    },
    // 验证角色
    validateRole(rule, value, callback) {
      if (value === "") {
        callback(new Error("请选择角色"));
      } else {
        callback();
      }
    },
    // 获取验证码
    getCode() {
      if (!this.registerForm.mobile) {
        this.$message({
          type: 'error',
          message: `请输入手机号！`
        });
        return
      }
      // 校验手机号格式是否正确
      if (!this.validateMobile(this.registerForm.mobile)) {
        this.$message({
          type: 'error',
          message: `请输入正确的手机号码！`
        });
        return
      }
      if (this.registerForm.password !== this.registerForm.re_password) {
        this.$message({
          type: 'error',
          message: `两次输入密码不一致！`
        });
        return
      }
      this.time = 59;
      let timer = setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          clearInterval(timer);
        }
      }, 1000);

      sendSmsCode({mobile: this.registerForm.mobile, type: '1'}).then(res => {
        if (res.data.code != 10000) {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        } else {
          this.$message.success("验证码已发送");
        }
      })
    },

    goLogin() {
      this.$router.push("/login");
    },
    goRegister() {
      this.$refs["registerForm"].validate((valid) => {
        if (valid) {
          this.register();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    clearList() {
      const allTabs = this.$store.getters["router/tabs"]
      const closeableTabs = allTabs.filter(
          (tab) => tab.path !== "/user/user-center"
      );
      if (closeableTabs.length !== 0) {
        closeableTabs.forEach((tab) => {
          this.$store.dispatch("router/closeTab", tab.path);
        });
      }
    },
    setInfo(data) {
      // 清空后台列表缓存
      this.clearList()
      // 存储token
      this.$utils.setCookie("token", data.token, 1);
      this.$store.commit("SET_TOKEN", data.token);
      // 更新登录状态
      this.$store.commit("SET_LOGIN", true);
      this.$store.commit("SET_IS_CHECK", data.user.is_check);
      this.$store.commit("SET_USERINFO", data.user);
      this.showUser = true;
      // 检查是否有重定向路径
      setTimeout(() => {
        const redirect = this.$route.query.redirect;
        if (redirect) {
          // 如果有重定向路径，跳转到指定页面
          this.safeNavigate(redirect, {replace: true});
        } else {
          // 否则跳转到首页
          this.safeNavigate("/", {replace: true});
        }
      }, 500);
    },
    // 安全导航：避免对当前路由的重复跳转，并忽略重复导航错误
    safeNavigate(path, {replace = false} = {}) {
      if (!path) return;
      if (this.$route && this.$route.path === path) {
        return;
      }
      const nav = replace ? this.$router.replace(path) : this.$router.push(path);
      return nav && nav.catch && nav.catch(err => {
        if (err && err.name === 'NavigationDuplicated') {
          return;
        }
        throw err;
      });
    },
    async register() {
      try {
        this.registerForm.mobile_prefix = this.select
        let res = await register(this.registerForm);
        if (res.data.code === 10000) {
          this.$message.success({
            message: "注册成功!将跳转至登录页面",
            center: true,
            offset: 250,
          });
          this.clearList()
          this.setInfo(res.data.data)
        } else {
          this.$message.error({
            message: res.data.message,
            center: true,
            offset: 250,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.btn-code {
  width: 100px;
  height: 40px;
  background: #ebebeb;
  border-radius: 2px 2px 2px 2px;
  border: 1px solid #eef0f5;
  text-align: center;
  line-height: 40px;
  font-weight: 400;
  font-size: 14px;
  color: #00112b;
  cursor: pointer;
}

.box {

  min-width: 100vw;
  min-height: 100vh;
  background: url("../../static/login/login-bj.png") no-repeat center center;
  background-size: 100% 100%;
  overflow: visible;

  .content {
    padding-top: 109px;
    display: flex;
    justify-content: space-between;

    .logo-word {
      height: 61px;
      display: flex;
      color: #000000;
      //width: 172px;
      align-items: center;
      margin-right: 32px;

      .logo-big {
        width: 200px;
        height: 62px;
        object-fit: contain;
      }

      .word-big {
        margin-left: 10px;

        .china-word {
          white-space: nowrap;
          font-size: 22px;
          // color: #00112b;
          color: #ffffff;
          font-weight: 700;
        }

        .english-word {
          white-space: nowrap;
          font-size: 11px;
          color: #ffffff;
        }
      }
    }

    .flex-inner-right {
      width: 380px;
      background: #ffffff;
      box-shadow: 0px 0px 11px 1px rgba(0, 11, 28, 0.13);
      border-radius: 5px 5px 5px 5px;
      box-sizing: border-box;
      margin-top: 5%;

      .flex-inner-right-img {
        position: absolute;
        margin-left: 334px;
        padding: 3px 3px 0 0;
        width: 44px;
        height: 44px;
      }

      .flex-inner-right-box {
        float: left;
        padding: 20px 13px;
        width: 100%;
        height: 100%;
        box-sizing: border-box;

        .flex-inner-right-box-title {
          font-weight: 800;
          font-size: 20px;
          color: #00112b;
          text-align: center;
          padding-bottom: 20px;
        }

        .menu-box {
          padding-top: 20px;
          display: flex;
          align-content: center;
          border-bottom: 1px solid #e5e5e5;
          justify-content: space-around;
        }

        .menu-item {
          box-sizing: border-box;
          text-align: center;
          font-weight: bold;
          font-size: 14px;
          color: #00112b;
          padding-bottom: 8px;
          border-bottom: 1px solid transparent;
        }

        .menu-item-active {
          box-sizing: border-box;
          text-align: center;
          font-weight: bold;
          font-size: 14px;
          padding-bottom: 12px;
          color: #00112b;
          border-bottom: 1px solid #246dff;
        }

        .input-box {
          padding: 10px 40px 0;

          img {
            width: 13px;
            height: 13px;
          }

          .input-item {
            margin-bottom: 30px;

            .input-error {
              line-height: 30px;
              font-weight: 400;
              font-size: 12px;
              color: #eb5637;
            }

            .input-item-box {
              height: 40px;
              line-height: 40px;
              background: #ffffff;
              border-radius: 2px 2px 2px 2px;
              border: 1px solid #eef0f5;
              padding: 0 13px;

              img {
                width: 13px;
                height: 13px;
                margin-right: 15px;
              }

              input {
                border: none;

                &:focus {
                  outline: none;
                  /* 移除默认的轮廓线 */
                  box-shadow: none;
                  /* 移除可能的阴影效果 */
                  border: none;
                  /* 确保没有边框 */
                  -webkit-appearance: none;
                  /* 移除iOS上的默认样式 */
                  -moz-appearance: none;
                  /* 移除Firefox上的默认样式 */
                }

                /* 移除自动填充时的背景色 */
                &:-webkit-autofill,
                &:-webkit-autofill:hover,
                &:-webkit-autofill:focus {
                  -webkit-box-shadow: 0 0 0 30px white inset !important;
                }
              }
            }
          }
        }

        .login-box {
          padding: 0 40px;

          .btn-size {
            width: 100%;
            height: 40px;
          }

          .login-box-text {
            font-weight: 400;
            font-size: 13px;
            color: #00112b;
            text-align: center;
            padding-top: 20px;
          }

          .color-blue {
            color: #0c60e6;
            cursor: pointer;
          }

          .top-inner {
            margin-top: 8px;
          }
        }
      }
    }
  }
}
</style>
